// Y-axis formatter for large numbers
export const formatYAxis = (value: number): string => {
  if (value >= 1000000) return `${(value / 1000000).toFixed(1).replace(/\.0$/, '')}M`; // Format millions
  if (value >= 1000) return `${(value / 1000).toFixed(1).replace(/\.0$/, '')}K`; // Format thousands
  return value.toString();
};
